import React, { useEffect, useState } from 'react';
import { istSichtbar } from '../bedingung';
import api from '../axiosSetup';
import { useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select';
import CustomNavbar from '../CustomNavbar';

const ZRHaesApplyEdit = () => {
  const [formData, setFormData] = useState({});
  const [formFields, setFormFields] = useState([]);
  const [title, setTitle] = useState('');
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState([]);
  const [id, setId] = useState(null); // State für ID hinzufügen
  const navigate = useNavigate();
  const location = useLocation();
  const haesItem = location.state;

  useEffect(() => {
    if (haesItem && haesItem.ID) {
      setId(haesItem.ID); // ID im State speichern
    }

    api.get('/api/form/ZRHaesApplyEdit.jsx')
      .then(response => {
        const fields = response.data.fields;
        setFormFields(fields);
        setTitle(response.data.title);

        if (haesItem) {
          const initialData = {};

          fields.forEach(field => {
            const key = field.name;
            const item = haesItem[key];

            if (item !== undefined) {
              let val;
              let valMemberID;

              if (key === 'Anfrager' && typeof item === 'object' && item !== null && 'Name' in item) {
                val = item.Name;
                valMemberID = item.memberID;
                initialData["memberID"] = valMemberID;
              } else {
                val = typeof item === 'object' && item !== null && 'value' in item ? item.value : item;
              }

              if (field.type === 'date' && typeof val === 'string') {
                if (/^\d{2}\.\d{2}\.\d{4}$/.test(val)) {
                  const [day, month, year] = val.split('.');
                  if (field.dateFormat === 'yyyy') {
                    val = year;
                  } else if (field.dateFormat === 'yyyy-MM') {
                    val = `${year}-${month}`;
                  } else {
                    val = `${year}-${month}-${day}`;
                  }
                }
              }

              if (key === 'schuhgroesse' && val) {
                initialData['schuhe'] = true;
              }

              if (field.type === 'checkbox') {
                // Falls Backend "Ja"/"Nein" liefert → in Boolean umwandeln
                if (typeof val === 'string') {
                  val = val.toLowerCase() === 'ja';
                } else {
                  val = Boolean(val);
                }
              }

              if (field.type === 'multiselect' && Array.isArray(val)) {
                val = val.map(v => typeof v === 'object' && v.value ? v.value : v);
              }

              if (field.type === 'multiselect' && Array.isArray(val)) {
                val = val.map(item => {
                  const match = field.options.find(opt => opt["frontend-text"] === item);
                  return match ? match.value : item;
                });
              }
              
              

              initialData[key] = val;
            }
          });

          setFormData(initialData);
        }

        setLoading(false);
      })
      .catch(error => {
        console.error('Fehler beim Laden des Formulars:', error);
        setLoading(false);
      });
  }, [haesItem]);

  const handleInputChange = (e, fieldName) => {
    setFormData({
      ...formData,
      [fieldName]: e.target.value
    });
  };

  const handleCheckboxChange = (e, fieldName) => {
    setFormData({
      ...formData,
      [fieldName]: e.target.checked
    });
  };

  const handleMultiSelectChange = (selectedOptions, fieldName) => {
    setFormData({
      ...formData,
      [fieldName]: selectedOptions ? selectedOptions.map(option => option.value) : []
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const invalidFields = [];
  
    formFields.forEach(field => {
      if (field.required && (formData[field.name] === undefined || formData[field.name] === '')) {
        invalidFields.push(field.label);
      }
    });
  
    if (invalidFields.length > 0) {
      setErrors(invalidFields);
      return;
    }
  
    const submitData = { ...formData };
  
    formFields.forEach(field => {
      const val = submitData[field.name];
  
      // ✅ NICHT mappen – wir behalten den Value so wie er ist
  
      // 🗓️ Falls Monats-Datum (yyyy-MM) → nur Jahr extrahieren
      if (field.type === "date" && typeof val === "string" && /^\d{4}-\d{2}$/.test(val)) {
        submitData[field.name] = val.substring(0, 4);
      }
    });
  
    submitData["ID"] = id;
  
    try {
      const token = localStorage.getItem("authToken");
      await api.post("/api/update-haes-apply-zuftrat", submitData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      navigate("/zr-haes", { state: { message: "Antrag wurde erfolgreich bearbeitet!" } });
    } catch (error) {
      console.error("Fehler beim Absenden:", error);
      setErrors(["Fehler beim Absenden. Bitte erneut versuchen."]);
    }
  };
  

  const renderFormFields = () => {
    return formFields.map((field, index) => {
      // Überprüfung der 'showIf' Bedingung
      if (!istSichtbar(field, formData)) return null;
  
      const isDisabled = field.disabled === true;
  
      switch (field.type) {
        // Nur eine Markierung im Schema: der Server setzt dahinter die
        // typabhaengigen Fragen ein. Angezeigt wird sie nicht.
        case 'type-questions':
          return null;
        case 'label':
          return (
            <div className="mb-3" key={index}>
              <label className="form-label fw-bold">{field.label}{field.required && <span className="text-danger ms-1">*</span>}</label>
              <p>{formData[field.name] || ''}</p>
            </div>
          );
        // Beide Faelle rendern gleich. Beim Typfeld fuellt der Server die
        // Optionen aus tbl_costume_types, statt sie im Formularschema
        // mitzuschleppen.
        case 'costume-type-select':
        case 'select':
          return (
            <div className="mb-3" key={index}>
              <label htmlFor={field.name} className="form-label">{field.label}{field.required && <span className="text-danger ms-1">*</span>}</label>
              <select
                className="form-select"
                id={field.name}
                name={field.name}
                value={formData[field.name] || ''} // ← bleibt gleich
                onChange={(e) => handleInputChange(e, field.name)}
                required={field.required}
              >
                <option value="">--bitte auswählen--</option>
                {field.options.map((option, idx) => (
                  <option key={idx} value={option.value}>
                    {option["frontend-text"]}
                  </option>
                ))}
              </select>

            </div>
          );
        case 'multiselect':
          return (
            <div className="mb-3" key={index}>
              <label htmlFor={field.name} className="form-label">{field.label}{field.required && <span className="text-danger ms-1">*</span>}</label>
              <Select
                isMulti
                options={field.options.map(option => ({
                  value: option.value, // Wert des Options-Objekts
                  label: option['frontend-text'] // Der Text, der angezeigt wird
                }))}
                value={(formData[field.name] || []).map(value => ({
                  value,
                  label: field.options.find(option => option.value === value)?.['frontend-text']
                }))}
                onChange={(selectedOptions) => handleMultiSelectChange(selectedOptions, field.name)}
                isDisabled={isDisabled}
                styles={{
                  control: (base) => ({
                    ...base,
                    borderRadius: '10px',
                    padding: '10px',
                  }),
                  multiValue: (base) => ({
                    ...base,
                    backgroundColor: '#6c757d',
                    color: 'white',
                  }),
                  option: (base) => ({
                    ...base,
                    color: 'black', // Textfarbe der Optionen
                  }),
                }}
              />
            </div>
          );
        case 'date':
          return (
            <div className="mb-3" key={index}>
              <label htmlFor={field.name} className="form-label">{field.label}{field.required && <span className="text-danger ms-1">*</span>}</label>
              <input
                type="date"
                className="form-control"
                id={field.name}
                name={field.name}
                value={formData[field.name] || ''}
                onChange={(e) => handleInputChange(e, field.name)}
                required={field.required}
                disabled={isDisabled}
              />
            </div>
          );
        case 'checkbox':
          return (
            <div className="mb-3 form-check" key={index}>
              <input
                type="checkbox"
                className="form-check-input"
                id={field.name}
                name={field.name}
                checked={formData[field.name] || false}
                onChange={(e) => handleCheckboxChange(e, field.name)}
                disabled={isDisabled}
              />
              <label className="form-check-label" htmlFor={field.name}>{field.label}{field.required && <span className="text-danger ms-1">*</span>}</label>
            </div>
          );
        case 'number':
          return (
            <div className="mb-3" key={index}>
              <label htmlFor={field.name} className="form-label">{field.label}{field.required && <span className="text-danger ms-1">*</span>}</label>
              <input
                type="number"
                className="form-control"
                id={field.name}
                name={field.name}
                value={formData[field.name] || ''}
                onChange={(e) => handleInputChange(e, field.name)}
                required={field.required}
                disabled={isDisabled}
              />
            </div>
          );
        case 'text':
          return (
            <div className="mb-3" key={index}>
              <label htmlFor={field.name} className="form-label">{field.label}{field.required && <span className="text-danger ms-1">*</span>}</label>
              <input
                type="text"
                className="form-control"
                id={field.name}
                name={field.name}
                value={formData[field.name] || ''}
                onChange={(e) => handleInputChange(e, field.name)}
                required={field.required}
                disabled={isDisabled}
              />
            </div>
          );
          case 'textarea':
            return (
              <div className="mb-3" key={index}>
                <label htmlFor={field.name} className="form-label">{field.label}{field.required && <span className="text-danger ms-1">*</span>}</label>
                <textarea
                  className="form-control"
                  id={field.name}
                  name={field.name}
                  value={formData[field.name] || ''}
                  onChange={(e) => handleInputChange(e, field.name)}
                  required={field.required}
                  disabled={isDisabled}
                  rows={field.rows || 4} // Optional: anpassbare Anzahl Zeilen
                />
              </div>
            );
        default:
          return null;
      }
    });
  };
  
  

  if (loading) {
    return <div>Lade Formular...</div>;
  }

  return (
    <div className="container mt-4">
      <CustomNavbar />
      <h2>{title}</h2>
      {errors.length > 0 && (
        <div className="alert alert-danger">
          Fehler: {errors.join(', ')}
        </div>
      )}
      <form onSubmit={handleSubmit}>
        {renderFormFields()}
        <button type="submit" className="btn btn-primary">Speichern</button>
      </form>
      <br/>
      <br/>
    </div>
    
  );
};

export default ZRHaesApplyEdit;
